import React from 'react';

import { Button } from '@elements/button';
import { TextWithMd } from '@elements/text/textWithMd';
import { i18n } from '@i18n';
import { testProps } from '@utils';

export interface Props {
  onNext: () => Promise<void> | void;
  isLoading: boolean;
}

export const DestinationsFooter: React.FC<Props> = ({ isLoading, onNext }) => {
  return (
    <div className="flex w-full flex-col items-center gap-4 justify-items-start">
      <Button
        variant="primary"
        onClick={onNext}
        title="Next"
        isLoading={isLoading}
        className="w-full"
        {...testProps('country-destination-select-next-button')}
      />
      <TextWithMd className="leading-5" variant="subHeading-14/m">
        {i18n.t('selectDestinations.footer.note')}
      </TextWithMd>
    </div>
  );
};
